import { reactive } from "vue";
import { inicial, processar} from "./BotApi";


const tiposInteracao = {
    final: 'FINAL', intermediario: 'INTERMEDIARIO', perguntaResposta: "PERGUNTA_RESPOSTA", resposta: "RESPOSTA", restart: "RESTART"
}

let id = reactive(0);

function persistInicial(mensagens) {
    localStorage.setItem('inicial', JSON.stringify(mensagens));
}

async function resetPersist() {
    localStorage.removeItem("inicial");
}

function getInicial() {
    try {
        let str = localStorage.getItem('inicial');
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

async function inicio() {
    let mensagens = getInicial();
    if (!mensagens) {
        const res = await inicial();
        mensagens = [];
        mensagens.push(interacaoToMensage(res.data))
        persistInicial(mensagens);
    }
    return mensagens;
}


async function onResposta(resposta) {

    const res = await processar({ identificador: resposta.identificador, resposta: { valor: resposta.value, data: resposta.data } }); // envia a resposta do usuário para o servidor e receber a próxima interação do bot
    const message = interacaoToMensage(res.data);

    if (message.tipo == tiposInteracao.final) {
        return [message, {
            texto: "Este é o fim da nossa interação! Por favor, digite qualquer coisa para reiniciar a nossa conversa, se tiver mais alguma dúvida!",
            tipo: tiposInteracao.restart
        }]
    }
    // colocar a resposta do usuario
    return [message]; // transforma a interação em uma mensagem e retorna um array com essa mensagem

}

async function onIput(text, ultimaMensagem) {
    if (!text) return;
    let mensagens = [];
    var data = null
    if(ultimaMensagem.tipo == tiposInteracao.restart) return 'RESTART'

    if (ultimaMensagem.tipo == tiposInteracao.perguntaResposta) {
        try {
            data = ultimaMensagem.resposta.data ? ultimaMensagem.resposta.data : null;
            const resposta = await this.onResposta({ identificador: ultimaMensagem.identificador, value: text, data: data });
            mensagens = mensagens.concat(resposta)
        } catch (error) {
            let interacaoPassada = { ...ultimaMensagem };
            interacaoPassada.feedback = "Entrada inválida! Por favor, informe novamente.";

            mensagens.push(interacaoPassada);
        }
    }

    if (ultimaMensagem.tipo == tiposInteracao.intermediario || ultimaMensagem.tipo == tiposInteracao.resposta) {
        const opcoes = ultimaMensagem.opcoes || []
        const indice = parseInt(text);
        const selecionado = opcoes[indice - 1];
        if (!selecionado) {
            let interacaoPassada = { ...ultimaMensagem };
            interacaoPassada.feedback = "Opção Inválida! Informe o número de um dos tópicos:"       
            mensagens.push(interacaoPassada);
            console.log(mensagens)
        } else {
            data = ultimaMensagem.resposta.data ? ultimaMensagem.resposta.data : null;
            const resposta = await onResposta({ identificador: ultimaMensagem.identificador, value: selecionado.value, data: data });
            mensagens = mensagens.concat(resposta)
        }
    }

    return mensagens;
}

function interacaoToMensage(interacao) {
    if (!interacao.tipo) {
        console.error('interacao sem tipo', interacao);
        throw ('interacao sem tipo')
    }
    switch (interacao.tipo) {
        case tiposInteracao.resposta:
            return fromInteracaoResposta(interacao);
        case tiposInteracao.final:
            return fromInteracaoFinal(interacao);
        case tiposInteracao.intermediario:
            return fromInteracaoIntermediaria(interacao)
        case tiposInteracao.perguntaResposta:
            return fromInteracaoPerguntaResposta(interacao)
        default:
            break;
    }
    return null;
}

function fromInteracaoFinal(interacao) {
    return {
        id: id++,
        identificador: interacao.identificador,
        isUser: false,
        texto: interacao.mensagem,
        link: interacao.link,
        opcoes: parseOpcoes(interacao),
        tipo: interacao.tipo,
        resposta: interacao.resposta,
    }
}

function fromInteracaoResposta(interacao) {
    return {
        id: id++,
        identificador: interacao.identificador,
        isUser: false,
        texto: interacao.mensagem,
        link: interacao.link,
        opcoes: parseOpcoesConfirmacao(interacao),
        tipo: interacao.tipo,
        feedback: interacao.feedback !== null ? interacao.feedback : null,
        resposta: interacao.resposta,
        html: interacao.html
    }
}

function fromInteracaoIntermediaria(interacao) {
    return {
        id: id++,
        identificador: interacao.identificador,
        isUser: false,
        texto: interacao.label,
        opcoes: parseOpcoes(interacao),
        tipo: interacao.tipo,
        feedback: interacao.feedback,
        resposta: interacao.resposta
    }
}

function fromInteracaoPerguntaResposta(interacao) {
    return {
        id: id++,
        identificador: interacao.identificador,
        isUser: false,
        texto: interacao.label,
        tipo: interacao.tipo,
        feedback: interacao.feedback,
        resposta: interacao.resposta,
        html: interacao.html
    }
}

function parseOpcoes(interacao) {
    if (interacao.tipo != 'INTERMEDIARIO' && !interacao.interactions)
        return undefined;

    return interactionsToOpcoes(interacao);
}

function parseOpcoesConfirmacao(interacao) {
    return confirmacaoToOpcoes(interacao);
}

function interactionsToOpcoes(interacao) {
    return interacao.interactions.map(i => ({ value: i.identificador, texto: i.label, identificador: interacao.identificador, link: i.link }));
}

function confirmacaoToOpcoes(interacao) {
    if(interacao.resposta !== null) {
        return interacao.resposta.opcoes.map(i => ({ value: i.identificador, texto: i.label, identificador: interacao.identificador }));
    } else {
        return null;
    }
    
}

export default {
    inicio, onResposta, tiposInteracao, onIput, resetPersist
}